export default __webpack_public_path__ + "static/media/sensotrend_signin_login.51a3c50c.png";